export const POST_RECORD = 'post_record';
export const SHARE_PAGE = 'share_page';
export const DASHBOARD = 'dashboard';
